(function () {
  // Mirrors the CSS :hover / :focus-within visibility of the mega-menu,
  // full-screen menu, and submenu panels into aria-expanded on their
  // trigger link, so screen readers get the same open/closed state that
  // sighted users see. Purely additive - the CSS still controls visibility.
  function initHeaderMenuAria(root) {
    root
      .querySelectorAll(".list-menu--inline > .list-menu-item")
      .forEach((item) => {
        const trigger = item.querySelector(
          ':scope > a[aria-haspopup="true"]'
        );
        if (!trigger || trigger.dataset.headerMenuAriaReady) return;
        trigger.dataset.headerMenuAriaReady = "true";

        const setExpanded = (isExpanded) => {
          trigger.setAttribute("aria-expanded", String(isExpanded));
        };

        item.addEventListener("mouseenter", () => setExpanded(true));
        item.addEventListener("mouseleave", () => setExpanded(false));
        item.addEventListener("focusin", () => setExpanded(true));
        item.addEventListener("focusout", (event) => {
          if (!item.contains(event.relatedTarget)) setExpanded(false);
        });
      });
  }

  initHeaderMenuAria(document);
  document.addEventListener("shopify:section:load", function (event) {
    initHeaderMenuAria(event.target);
  });
})();
